module.exports = __webpack_public_path__ + "static/media/hero.7e9a7d34.svg";